/*
 * VOITKUS — delivery ETA line (snippets/delivery-eta.liquid).
 * Order day + N working days (Mon–Fri); orders after the cut-off hour (Warsaw time) count from the next day;
 * holidays from theme settings. Settings arrive as data-vk-eta-* attributes on every [data-vk-eta] element.
 * window.vkEta = { compute, paint }; [data-vk-eta] nodes added later (e.g. mini-cart re-render) are painted too.
 */
(() => {
  'use strict';
  if (window.vkEta) return;

  const WD = ['w niedzielę', 'w poniedziałek', 'we wtorek', 'w środę', 'w czwartek', 'w piątek', 'w sobotę'];
  const MONTHS = ['stycznia', 'lutego', 'marca', 'kwietnia', 'maja', 'czerwca', 'lipca', 'sierpnia', 'września', 'października', 'listopada', 'grudnia'];
  const pad = (n) => String(n).padStart(2, '0');
  const iso = (d) => `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}`;
  const addDay = (d) => new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate() + 1));
  const int = (value, fallback) => {
    const n = parseInt(value, 10);
    return Number.isNaN(n) ? fallback : n;
  };

  // Settings are global, so any ETA element carries the same values.
  function settings(el) {
    const source = el || document.querySelector('[data-vk-eta]');
    const data = (source && source.dataset) || {};
    let holidays = [];
    try {
      holidays = JSON.parse(data.vkEtaHolidays || '[]');
    } catch {
      holidays = [];
    }
    return {
      holidays: (Array.isArray(holidays) ? holidays : []).map((d) => String(d).trim()).filter(Boolean),
      cutoff: int(data.vkEtaCutoff, 17),
      days: int(data.vkEtaDays, 2),
    };
  }

  function compute(el) {
    const { holidays, cutoff, days } = settings(el);
    const isWork = (d) => { const w = d.getUTCDay(); return w !== 0 && w !== 6 && !holidays.includes(iso(d)); };
    const p = Object.fromEntries(new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Warsaw', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' })
      .formatToParts(new Date()).map((x) => [x.type, x.value]));
    const today = new Date(Date.UTC(+p.year, +p.month - 1, +p.day));
    const beforeCutoff = +p.hour < cutoff && isWork(today);
    let start = beforeCutoff ? today : addDay(today);
    while (!isWork(start)) start = addDay(start);
    let d = start, left = days;
    while (left > 0) { d = addDay(d); if (isWork(d)) left--; }
    const when = `${WD[d.getUTCDay()]}, ${d.getUTCDate()} ${MONTHS[d.getUTCMonth()]}`;
    const span = days === 1 ? '1 dzień roboczy' : (days < 5 ? `${days} dni robocze` : `${days} dni roboczych`);
    return (beforeCutoff
      ? `Zamów do ${cutoff}:00 — dostawa <b>${when}</b>`
      : `Zamów teraz — dostawa <b>${when}</b>`) + ` <span class="vk-eta__days">(${span})</span>`;
  }

  function paint(root) {
    (root || document).querySelectorAll('[data-vk-eta]').forEach((el) => {
      const t = el.querySelector('[data-vk-eta-text]');
      if (t) t.innerHTML = compute(el);
      el.hidden = false;
    });
  }

  window.vkEta = { compute, paint };

  const run = () => {
    paint();
    new MutationObserver((list) => {
      for (const m of list) for (const n of m.addedNodes) {
        if (n.nodeType === 1 && (n.matches('[data-vk-eta]') || n.querySelector('[data-vk-eta]'))) { paint(n.parentNode || document); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
